// src/theme/tokens/gradient.js
// Faz 1 · Gradient semantic token namespace.
// 'gradient.flashcard.*' / 'gradient.brand.*' / 'gradient.premium.*' /
// 'gradient.exam.*' / 'gradient.marketing.*' / 'gradient.reading.*' /
// 'gradient.glass.*' tokenlari kaldirildi (sifir kullanim teyit edildi).
// Mevcut flashcard hardcoded gradient'leri index.js icinde flashcardFrontGradient/
// BackGradient olarak yasamaya devam ediyor.

const gradientTokens = {};

export default gradientTokens;
